import { render, staticRenderFns } from "./dynamicDataPanel.vue?vue&type=template&id=039b000d&scoped=true"
import script from "./dynamicDataPanel.vue?vue&type=script&lang=js"
export * from "./dynamicDataPanel.vue?vue&type=script&lang=js"
import style0 from "./dynamicDataPanel.vue?vue&type=style&index=0&id=039b000d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039b000d",
  null
  
)

export default component.exports